import React from 'react';
import {RouteSelector} from '../../../../index';
import {useDispatch, useSelector} from "react-redux";
import {
    syncMainLegBetweenFlows,
    setSwState,
    setSwBookState,
    retrieveStopoverAvailability,
} from "../../../../../store/reducers/search-widget";
import {COMPONENTS} from "../../common/book-form-input-refs";
import {useMediaQuery, useTheme} from "@material-ui/core";
import {t} from 'ttag';


const RouteSelectorConnected = () => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('xs'));
    const allAirports = useSelector(state => state.sw.allAirports);
    const fullscreen = useSelector(state => state.sw.book.fullscreen);
    const origin = useSelector(state => state.sw.book.origin);
    const destination = useSelector(state => state.sw.book.destination);
    const passengerType = useSelector(state => state.sw.book.passengerType);
    const withMiles = useSelector(state => state.sw.book.withMiles);
    const isResidentOrStudent = ['RESIDENT', 'STUDENT'].includes(passengerType);
    const dispatch = useDispatch();

    let airports = [...allAirports];
    /** Filter Airline Operated Routes **/
    if (withMiles) {
        airports = allAirports
            .filter(airport => airport.airlineOperated)
            .map(airport => ({
                ...airport,
                destinations: airport.destinations.filter(destinationCode => {
                    return allAirports.find(a => a.code === destinationCode)?.airlineOperated;
                })
            }));
    }
    /** Filter OSP Routes **/
    /*if (isResidentOrStudent) {
        airports = allAirports
            .filter(airport => airport.countryName === 'Portugal')
            .map(airport => ({
                ...airport,
                destinations: airport.destinations.filter(destinationCode => {
                    return airport.azores || allAirports.find(a => a.code === destinationCode)?.azores;
                })
            }));
    }*/

    const isOSP = (o, d) => o?.countryName === 'Portugal' && d?.countryName === 'Portugal' && (o?.azores || d?.azores);

    return (
        <RouteSelector
            airportsData={airports}
            onChange={cityPair => {
                dispatch(setSwBookState({
                    origin: cityPair?.origin,
                    destination: cityPair?.destination,
                }));
                dispatch(syncMainLegBetweenFlows({toMultiCity: true}));
                if (isResidentOrStudent && !isOSP(cityPair?.origin, cityPair?.destination)) {
                    dispatch(setSwBookState({
                        passengerType: 'ADULT',
                        alertMessage: {severity: 'warning', children: t`Passenger type was changed.`}
                    }));
                }
                if (fullscreen) dispatch(setSwState({focusedComponent: COMPONENTS.DEPARTURE_REF}));
                dispatch(retrieveStopoverAvailability());
            }}
            origin={origin}
            destination={destination}
            variant={isMobile ? 'stacked' : (fullscreen ? 'normal' : 'small')}
            originPlaceholder={!isMobile && fullscreen ? t`Departure from...` : undefined}
            destinationPlaceholder={!isMobile && fullscreen ? t`Where do you want to go?` : undefined}
            compressed={!isMobile && !fullscreen}
        />
    );
};

export default RouteSelectorConnected;